import styled from 'styled-components';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { RemoveUndefined } from 'src/types';

export const Tooltip = styled(ReactTooltip)<RemoveUndefined<{}>>``;
